import React, {Fragment, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
    Button,
    Col,
    Modal,
    Pagination,
    PaginationItem,
    PaginationLink,
    Popover,
    PopoverBody,
    Row,
    Table
} from "reactstrap";
import {getIntegrationLogo} from 'helpers/component_helpers';
import {acceptTheSuggestion, getMostFrequentAlertsOpenAndClosedWithin5Minutes} from 'store/alertanalytics/actions';
import {Link} from "react-router-dom";
import {
    postDatadogServiceMapping as onPostDatadogServiceMapping,
    putDatadogAlerts as onPutDatadogAlerts
} from 'store/datadog/actions';
import CardItem from 'components/PurpleTheme/CardItem';
import {getServices as onGetServices} from "../../store/service/actions";
import Select from "react-select";
const DatadogMostFrequentAlertsCardForOptimisation = (props) => {
    const {
        title,
      activeTabIntegrationType,
      loading,
    } = props;

    const dispatch = useDispatch();
    const {mostFrequentAlertsForOptimizationOpenCloseWithin5Minutes} = useSelector(state => ({
        mostFrequentAlertsForOptimizationOpenCloseWithin5Minutes: state.AlertAnalytics.mostFrequentAlertsForOptimizationOpenCloseWithin5Minutes || {}
    }));
    const mostFrequentAlertsDatadog = mostFrequentAlertsForOptimizationOpenCloseWithin5Minutes
    useEffect(() => {
        if (activeTabIntegrationType !== 'Datadog') return;
        let payload = {
            'page': 1,
            'limit': itemsPerPage,
            'teamIds': [],
            'integration': 'Datadog'
        }
        dispatch(getMostFrequentAlertsOpenAndClosedWithin5Minutes(payload));
    }, [getMostFrequentAlertsOpenAndClosedWithin5Minutes, activeTabIntegrationType]);

    const changeHeaders = ['Current Threshold Duration', 'New Suggested Threshold Duration']
    const [deployModal, setDeployModal] = useState(false);
    const [changedAlertValues, setChangedAlertValues] = useState({});
    const [popoverOpen, setPopoverOpen] = useState({});
    const [popoverText, setPopoverText] = useState('');

    const handleSave = (item) => {
        setChangedAlertValues({
            id: item.id,
            alert_name: item.name,
            suggestion_id: item.alert_suggestion_id,
            threshold_duration: {
                old: item.threshold_duration,
                new: item.suggested_new_threshold_duration
            }
        });
        setMonitoredResourceDetails({
            "alert_id": item.id,
            'monitored_resource_id': item.monitored_resource_id,
            'monitored_resource_name': item.monitored_resource_name,
            "application_service_mapped": item.application_service_mapped
        });
        setDeployModal(true);
    };

    const handleSubmit = () => {
        const payload = {
            'datadog_alert_id': changedAlertValues.id,
            'threshold_duration': changedAlertValues.threshold_duration.new
        };
        dispatch(onPutDatadogAlerts(payload));
        dispatch(acceptTheSuggestion(changedAlertValues.suggestion_id));
        setDeployModal(false);
    };

    const itemsPerPage = 50
    const totalAlerts = mostFrequentAlertsDatadog?.count || 0
    const [selectedPage, setSelectedPage] = useState(1);

    const totalPages = Math.ceil(totalAlerts / itemsPerPage);
    let startPage = Math.max(selectedPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);
    if (endPage === totalPages) {
        startPage = Math.max(totalPages - 2, 1);
    }
    const handlePageClick = (pageNumber) => {
        let payload = {
            'page': pageNumber,
            'limit': itemsPerPage,
            'teamIds': [],
            'integration': 'Datadog'
        }

        setSelectedPage(pageNumber);
        dispatch(getMostFrequentAlertsOpenAndClosedWithin5Minutes(payload));

    }
    const togglePopover = (key, isOpen) => {
        setPopoverOpen(prevState => ({
            ...prevState,
            [key]: isOpen,
        }));
    };

    const handleMouseEnter = (key, name) => {
        setPopoverText(name);
        togglePopover(key, true);
    };

    const handleMouseLeave = (key) => {
        togglePopover(key, false);
    };

    const [serviceOptions, setServiceOptions] = useState([]);
    const [showMapToServiceModal, setShowMapToServiceModal] = useState(false);
    const [selectedService, setSelectedService] = useState(null);
    const [monitored_resource_details, setMonitoredResourceDetails] = useState({});
    useEffect(() => {
        dispatch(onGetServices());
    }, [onGetServices]);

    const reduxServices = useSelector(state =>
      state.Service.services
    );


    useEffect(() => {
        const options = reduxServices?.map((service) => ({
            value: service.id,
            label: service.name
        }));
        setServiceOptions(options);
    }, [reduxServices]);
    const customStyles = {
        zIndex: 9999,
        control: (provided, state) => ({
            ...provided,
            background: '#382b42', // Background color of the control (react-select)
            borderRadius: 0,
            color: "white",
            zIndex: 100,
            position:"relative",
            borderColor: state.isFocused ? 'rgb(white, 1)' : 'rgb(white, 0.7)', // Border color when focused
        }),
        option: (provided, state) => ({
            ...provided,
            position:"relative",
            zIndex: 100,
            backgroundColor: state.isSelected ? '#292036' : state.isFocused ? '#2d2941' : '#382b42',
            color: state.isSelected ? '#ffffff' : '#ffffff', // Text color of dropdown options
        }),
        menu: (provided) => ({
            ...provided,
            background: '#382b42',
            position: "absolute",
            zIndex: 200, // Background color of the dropdown menu

        }),
        singleValue: (provided) => ({
            ...provided,
            position:"relative",
            color: '#ffffff', // Color of the selected value
            zIndex: 100,
        }),
    };
    const handleServiceFormChange = (selectedOption) => {
        setSelectedService(selectedOption);
    };
    const [btnHover, setBtnHover] = useState(false);

    const customOptionRenderer = (option) => {
        if (option.value === "/add-service") {
            return (
              <div
                className="d-flex justify-content-center align-items-center gap-2 btn btn-soft-primary"
                onMouseEnter={() => setBtnHover(true)}
                onMouseLeave={() => setBtnHover(false)}
                style={{cursor:"pointer"}}>
                  <i className={`fas fa-plus font-size-14 ${btnHover ? 'text-white' : 'text-primary'}`} />
                  <span>
            {option.label}
          </span>
              </div>
            );
        } else {
            return option.label;
        }
    };
    function handleMapService(monitored_resource_id, value) {
        let payload = {
            'datadog_resource_ids': [monitored_resource_id],
            'application_service_id': value || ''
        };
        dispatch(onPostDatadogServiceMapping(payload));
        dispatch(getMostFrequentAlertsOpenAndClosedWithin5Minutes(payload));
        setShowMapToServiceModal(false);
    }

    function handleClickMapToService() {
        setShowMapToServiceModal(true);
    }

    return (
      loading? (
        <div className="text-center">
            <div className="mb-8">
                <h5 className="change-table-text">{title}</h5>
            </div>
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>):(
        <>
            <React.Fragment>
                <div>
                    <div className="mb-8">
                        <h5 className="change-table-text">{title}</h5>
                    </div>
                    {mostFrequentAlertsDatadog?.alerts?.length > 0 && (<Pagination aria-label="pagination navigation"
                                                                                   listClassName="justify-content-end pagination-rounded"
                                                                                   className="mb-3">
                        {totalPages > 1 && (
                            <PaginationItem key={Math.max(selectedPage - 1, 1)} disabled={selectedPage === 1}>
                                <PaginationLink
                                    href=""
                                    onClick={() => handlePageClick(Math.max(selectedPage - 1, 1))}
                                >
                                    <i className="mdi mdi-chevron-left"/>
                                </PaginationLink>
                            </PaginationItem>
                        )}

                        {[...Array(endPage - startPage + 1)].map((_, index) => (
                            <PaginationItem key={startPage + index} active={selectedPage === startPage + index}>
                                <PaginationLink href="" onClick={() => handlePageClick(startPage + index)}>
                                    {startPage + index}
                                </PaginationLink>
                            </PaginationItem>
                        ))}
                        {totalPages > 1 && (
                            <PaginationItem key={Math.min(selectedPage + 1, totalPages)}
                                            disabled={selectedPage === totalPages}>
                                <PaginationLink
                                    href=""
                                    onClick={() => handlePageClick(Math.min(selectedPage + 1, totalPages))}
                                >
                                    <i className="mdi mdi-chevron-right"/>
                                </PaginationLink>
                            </PaginationItem>
                        )}
                    </Pagination>)}
                    <div>
                        <Table>
                            {mostFrequentAlertsDatadog?.alerts?.length > 0 && (
                                <Row className={'mb-4'}>
                                <div className="d-flex align-items-center" style={{backgroundColor: "transparent"}}>
                                    <Col
                                      md ={2}
                                      style={{textAlign: 'center', verticalAlign: 'middle'}}>Integration</Col>
                                    <Col
                                      md ={2}
                                      style={{textAlign: 'center', verticalAlign: 'middle'}}>Monitored
                                        Resource
                                    </Col>
                                    <Col
                                      md={2}
                                      style={{textAlign: 'center', verticalAlign: 'middle'}}>Alert
                                        Name
                                    </Col>
                                    <Col
                                      md={2}
                                      style={{textAlign: 'center', verticalAlign: 'middle'}}>Metric
                                        Name
                                    </Col>
                                    <Col
                                      md={1}
                                      style={{textAlign: 'center', verticalAlign: 'middle'}}>Threshold
                                    </Col>
                                    <Col
                                      md={1}
                                      style={{textAlign: 'center', verticalAlign: 'middle'}}>Threshold
                                        Duration
                                    </Col>
                                    <Col
                                      md={2}
                                      style={{textAlign: 'center', verticalAlign: 'middle'}}>Action</Col>
                                </div>
                                </Row>
                            )}
                            <>

                            {mostFrequentAlertsDatadog?.alerts?.length > 0 ? (
                                mostFrequentAlertsDatadog.alerts.map((item, index) => (
                                <CardItem key={index} style={{borderBottom: "1px solid #696283"}}>
                                    <Row>
                                        <div className="d-flex align-items-center" style={{backgroundColor: "transparent"}}>
                                            <Col
                                              md={2}
                                              style={{textAlign: 'center', verticalAlign: 'middle'}}>
                                                <div className="text-center">
                                                    <img
                                                      src={getIntegrationLogo('Datadog').replace(/\s+/g, '')}
                                                      alt={'Datadog'}
                                                      className="avatar-xs rounded-circle"
                                                    />
                                                </div>
                                            </Col>
                                            <Col
                                              md={2}
                                              style={{textAlign: 'center', verticalAlign: 'middle'}}>
                                                <Link
                                                  to={`/datadog/resource/${item?.monitored_resource_id}/alerts`}
                                                  className="link-primary"
                                                >
                                                    <p className="mb-0">{item?.monitored_resource_name}</p>
                                                </Link>
                                            </Col>
                                            <Col
                                              onMouseEnter={() => handleMouseEnter(`${index}_alert_name`, item?.name)}
                                              onMouseLeave={() => handleMouseLeave(`${index}_alert_name`)}
                                              style={{verticalAlign: 'middle', textAlign: 'center'}}
                                              md={2}>
                                                <p
                                                  id={`resource-link-${index}_alert_name`}
                                                  className="mb-0 resource-name-truncate">{item?.name}</p>
                                            </Col>
                                            <Popover isOpen={popoverOpen[`${index}_alert_name`] || false} target={`resource-link-${index}_alert_name`} placement="top">
                                                <PopoverBody>{popoverText}</PopoverBody>
                                            </Popover>
                                            <Col
                                              onMouseEnter={() => handleMouseEnter(`${index}_metric_name`, item?.metric_name)}
                                              onMouseLeave={() => handleMouseLeave(`${index}_metric_name`)}
                                              style={{verticalAlign: 'middle', textAlign: 'center'}}
                                              md={2}>
                                                <p
                                                  id={`resource-link-${index}_metric_name`}
                                                  className="mb-0 resource-name-truncate">{item?.metric_name}</p>
                                            </Col>
                                            <Popover isOpen={popoverOpen[`${index}_metric_name`] || false} target={`resource-link-${index}_metric_name`} placement="top">
                                                <PopoverBody>{popoverText}</PopoverBody>
                                            </Popover>
                                            <Col
                                              md={1}
                                              style={{textAlign: 'center', verticalAlign: 'middle'}}>
                                                <p className="mb-0">{item?.threshold}</p>
                                            </Col>
                                            <Col
                                              md={1}
                                              style={{textAlign: 'center', verticalAlign: 'middle'}}>
                                                <p className="mb-0">{item?.threshold_duration}</p>
                                            </Col>
                                            <Col
                                              md={2}
                                              style={{textAlign: 'center', verticalAlign: 'middle'}}>
                                                <button
                                                  type="button"
                                                  className="btn btn-primary w-md"
                                                  onClick={() => handleSave(item)}
                                                >
                                                    View Suggestion
                                                </button>
                                            </Col>

                                        </div>

                                    </Row>
                                </CardItem>
                                ))) : (<Row>
                                <Col md={12} style={{textAlign: 'center'}}>
                                    We do not have any alert suggestions for you at the moment.</Col>
                            </Row>)}
                            </>
                        </Table>
                    </div>
                </div>
            </React.Fragment>
            <Modal
                isOpen={deployModal}
                role="dialog"
                autoFocus={true}
                centered={true}
                className="exampleModal"
                size="xl"
                tabIndex="-1"
            >
                <div className="modal-header border-bottom-1 text-center">
                    <h4 className="text-primary">Optimizing the alert!</h4>
                    <button type="button" className="btn-close"
                            onClick={() => {
                                setDeployModal(!deployModal);
                            }}
                            aria-label="Close"
                    >
                    </button>
                </div>
                <div className="modal-body">
                    <div className="text-center mb-4">
                        <div className="row justify-content-center">
                            <div className="col-xl-10">
                                <p className="font-size-14 mb-4">
                                    Note: This does not affect your default thresholds. Only this alert will be
                                    modified.
                                </p>
                                <div className="table-responsive react-table">
                                    <Table bordered hover className='table-purple'>
                                        <thead className="table-light table-nowrap">
                                        <tr>
                                            <th>Alert Name</th>
                                            {changeHeaders.map((header, index) => (
                                                <th key={index}>
                                                    {header}
                                                </th>
                                            ))}
                                        </tr>
                                        </thead>
                                        {
                                            Object.entries({...changedAlertValues}).map(([key, value], index) => {
                                                if (typeof value === 'object' && value !== null) {
                                                    return (
                                                        <Fragment key={index}>
                                                            <tbody>
                                                            <tr>
                                                                <td>
                                                                    {changedAlertValues.alert_name}
                                                                </td>
                                                                <td>
                                                                    {value.old}
                                                                </td>
                                                                <td>
                                                                    <b>{value.new}</b>
                                                                </td>
                                                            </tr>
                                                            </tbody>
                                                        </Fragment>
                                                    )
                                                }
                                            })
                                        }
                                    </Table>
                                </div>
                                {monitored_resource_details && !monitored_resource_details.application_service_mapped ?(
                                  <Button
                                    color="primary"
                                    className={'me-2'}
                                    type="button"
                                    id="button-addon2"
                                    onClick={() => {
                                        handleClickMapToService();
                                    }}
                                  >
                                      Map to Service
                                  </Button>
                                ):null}
                                <Button
                                    color="primary"
                                    type="button"
                                    id="button-addon2"
                                    disabled={!monitored_resource_details.application_service_mapped || false}
                                    onClick={() => {
                                        handleSubmit();
                                    }}
                                >
                                    Deploy Alert
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal isOpen={showMapToServiceModal}>
                <div className="modal-header border-bottom-1 text-center">
                    <h4 className="text-primary"> Map to Service to enable deployment</h4>
                    <button type="button" className="btn-close"
                            onClick={() => {
                                setShowMapToServiceModal(!showMapToServiceModal);
                            }}
                            aria-label="Close"
                    >
                    </button>
                </div>
                {monitored_resource_details && !monitored_resource_details.application_service_mapped ? (
                  <div className='d-flex flex-column justify-content-center p-4 align-items-center'>
                      <p className='text-white'>
                          Map the resource
                          <span className={'ms-1'}>{monitored_resource_details.monitored_resource_name}.</span>
                      </p>
                      <div className='d-flex flex-row'>
                          <div className="mb-2 d-flex me-2">
                              <Select
                                isClearable
                                value={serviceOptions.find(option => option.label === selectedService)}
                                options={[
                                    ...serviceOptions,
                                    { value: "/add-service", label: "Add new service" }
                                ]}
                                placeholder={'Select a Service'}
                                onChange={(selectedOption) => {
                                    if (selectedOption && selectedOption.value === "/add-service") {
                                        window.location.href = "/add-service";
                                    } else {
                                        handleServiceFormChange(selectedOption);
                                    }
                                }}
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                    colors: {
                                        ...theme.colors,
                                        neutral0: '#222736',
                                        neutral5: '#485EC4',
                                        neutral10: '#485EC4',
                                        neutral60: '#ffffff',
                                        neutral70: '#ffffff',
                                        neutral80: '#ffffff',
                                        neutral90: '#ffffff',
                                        primary: '#485EC4',
                                    },
                                })}
                                styles={customStyles}
                                getOptionLabel={(option) => customOptionRenderer(option)}
                              />
                          </div>
                          <div>
                              <button
                                type={"button"}
                                className={"btn btn-primary"}
                                onClick={() => {
                                    handleMapService(monitored_resource_details.monitored_resource_id, selectedService.value);
                                }}
                              >Map to service</button>
                          </div>

                      </div>

                  </div>
                ) : null}
            </Modal>
        </>
      )
    );
};

export default DatadogMostFrequentAlertsCardForOptimisation;
